/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TimeOnlyFormats {
    IncludeSeconds = 1,
    DoNotIncludeSeconds = 2,
}
